import React from 'react';
// Drag and drop is now handled entirely by the parent Codebook component
import TextCodeModal from './TextCodeModal';
import TextCodeExcerptsModal from './TextCodeExcerptsModal';

const CodeCard = ({ code, textCodes, setUploadAudioModal, handleUpdateCode, handleAddNewCode, handleDeleteCode, t, isReGroupMode, isDropZone, isDraggedOver, draggedItem, ...rest }) => {

    // Determine if this card can accept drops
    const canAcceptDrop = isReGroupMode && draggedItem && draggedItem.uuid !== code.uuid;
    
    // Drop zone styling
    const dropZoneStyle = {
        backgroundColor: canAcceptDrop && isDraggedOver ? code.color : code.color,
        opacity: canAcceptDrop && isDraggedOver ? 0.8 : 1,
        border: canAcceptDrop && isDraggedOver ? '3px dashed #374151' : 'none',
        position: 'relative'
    };

    return (
        <div className='flex flex-col rounded-md px-4 py-4' style={dropZoneStyle} data-testid={`code-card-${code.uuid}`} {...rest}>
            {/* Drop zone message */}
            {canAcceptDrop && isDraggedOver && (
                <div className='absolute inset-0 flex items-center justify-center bg-black bg-opacity-20 rounded-md z-10'>
                    <div className='bg-white px-4 py-2 rounded-md shadow-lg text-sm font-semibold'>
                        {t('DetailProjects.Drop here to move')}
                    </div>
                </div>
            )}
            <span className='font-bold flex items-center gap-4' data-testid={`code-card-name-${code.uuid}`}>
                <div className='bg-black rounded-full text-white text-sm w-8 h-8 flex justify-center items-center' data-testid={`code-card-excerpt-count-${code.uuid}`}>
                    {code?.excerpts?.length || 0}
                </div>
                {code.name}
            </span>
            <span className='text-gray-700 text-sm mt-2' data-testid={`code-card-description-${code.uuid}`}>{code.description}</span>
            {!isReGroupMode && code.reasoning && (
                <span className='text-gray-600 text-sm mt-2 italic' data-testid={`code-card-reasoning-${code.uuid}`}>
                    <strong>Reasoning:</strong> {code.reasoning}
                </span>
            )}

            {!isReGroupMode && (
                <div className='flex justify-end gap-4 mt-4'>
                    <button className='bg-white text-black rounded-md px-4 py-2 text-sm'
                        data-testid={`code-card-edit-btn-${code.uuid}`}
                        onClick={() => setUploadAudioModal(
                            <TextCodeModal
                                code={code}
                                handleClose={() => setUploadAudioModal(null)}
                                handleUpdateCode={handleUpdateCode}
                                handleAddNewCode={handleAddNewCode}
                                handleDeleteCode={handleDeleteCode}
                                textCodes={textCodes}
                            />
                        )}>
                        {t('DetailProjects.Edit')}
                    </button>
                    <button className='bg-black text-white rounded-md px-4 py-2 text-sm'
                        data-testid={`code-card-view-entries-btn-${code.uuid}`}
                        onClick={() => setUploadAudioModal(
                            <TextCodeExcerptsModal
                                handleClose={() => setUploadAudioModal(null)}
                                code={code}
                            />
                        )}>
                        {t('DetailProjects.View entries')}
                    </button>
                </div>
            )}
            {/* Child codes are now handled entirely by the parent Codebook component */}
            {/* This prevents duplicate rendering and index conflicts */}

        </div>
    );
};

export default CodeCard;
